export default {
	home: {
		title: "Personalized digital event guide",
		intro: "Conflive is a new event guide mobile application for modern conferences. It can be used to inform visitors, rate presentations, share related publications and display real-time quiz questions. It is a must have tool for all kind of events, as the most convenient way to communicate with the participants.",
		features: "Features",
		references: "References",
		referencesDesc: "Our latest supported event: Startup Safary 2017. The applications can be downloaded from these links:",
		team: "Our team",
		contact: "Contact",
		contactDesc: "Contact us for the pricing and more information.",
		feats: {
			"1title": "Schedule and list of speakers",
			"1desc": "Presenting the schedule information is the most important feature. Through this, the visitors can access contact information and attachments too.",
			
			"2title": "Sponsor categories",
			"2desc": "Beyond the information sharing, the application is a great advertising space for the sponsors. They can also be categorized based on their support level.",
			
			"3title": "Presentation ratings",
			"3desc": "Every presentation can be rated on a scale of 1-6 which can help your work to select the best ones for future events.",
			
			"4title": "Live presentation indicator",
			"4desc": "For freestyle events, it is necessary to show the current presentations. We display them right on the main screen, right on time.",
			
			"5title": "Related questions",
			"5desc": "We can attach questionaries to the presentations with single-select options. It can be used to check the understanding of the subject material or to organize small giveaways.",
			
			"6title": "Offline usage",
			"6desc": "The software was created with the use of modern toolkits, natively on iOS and Android platforms. After the first load, they can be used without internet access.",
			
			"7title": "Real time quiz",
			"7desc": "The visitors can answer the related questions in real-time, which can be presented directly on an external screen through a specialized web interface. This way, the speakers can reflect to their input during the presentations",
			
			"8title": "Location map",
			"8desc": "With multiple venue locations, it is necessary to display the exact position of the upcoming presentations. Our software can pair them with city maps and interior floor plans to indicate their location.",
			
			"9title": "Personalized features",
			"9desc": "Every event is different, this is why we always ready to develop new features. Just contact us to discuss your specific needs and create a new solution together."
		}
	}
}


// WEBPACK FOOTER //
// ./src/strings/en.js